import { AxiosPromise } from 'axios';

import { publicBaseInstance } from '@/lib/api';

interface Banner {
  id: number;
  documentId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string;
  visible: boolean;
  section: string;
  images: Array<{
    id: number;
    name: string;
    url: string;
    mime: string;
    redirectUrl: string | null;
    internalRoute: string | null;
    type?: string;
  }>;
}

/**
 * Fetches banners by client ID (CID) and locale.
 *
 * @param {Object} params - The parameters for the API request.
 * @param {string} params.cid - The client id.
 * @param {string} [params.locale='en'] - The locale (default is 'en').
 * @returns {AxiosPromise<{ banners: Banner[] }>} A promise that resolves with the banners data.
 */
export function fetchBanners({
  cid,
  locale = 'en',
}: {
  cid: string;
  locale?: string;
}): AxiosPromise<{ banners: Banner[] }> {
  const url = '/api/cms/banner/getByCid';
  return publicBaseInstance.get(url, {
    params: {
      cid,
      locale,
    },
  });
}
